
import { useEffect, useRef } from "react";
import { useUserData } from "../../context/UserData/UserDataContext";
import { useEvent } from "../context/EventContext";

export const useAmplitudeUserSync = () => {
    const { state } = useUserData();
    const { analyticsEvent } = useEvent();
    const prevCidRef = useRef<string | null>(null);

    useEffect(() => {
        if (!state.cid) return;

        if (prevCidRef.current === null) {
            analyticsEvent("setUserID", { cid: state.cid });
        } else if (prevCidRef.current !== state.cid) {
            analyticsEvent("resetUserID", { cid: state.cid });
        }

        prevCidRef.current = state.cid;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.cid]);
};